import React, { useEffect } from 'react'
import { Provider, useSelector, useDispatch } from 'react-redux'
import { RouterProvider } from 'react-router5'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import Loading from './components/system/Loading'
import Theme from './theme'
import SnackbarWrapper from './pages/SnackbarWrapper'
import Router from './router/Router'

import apiUtils from './store/api'
import systemActions from './store/modules/system'
import systemSelectors from './store/selectors/system'
import routerSelectors from './store/selectors/router'

const RootApp = ({
  store,
  router,
}) => {

  const dispatch = useDispatch()
  const loaded = useSelector(systemSelectors.loaded)
  const route = useSelector(routerSelectors.route)

  useEffect(() => {
    const init = async () => {
      await dispatch(systemActions.initialize())
      router.start()
    }
    init()
  }, [])

  if(!loaded) return <Loading />

  return (
    <Theme>
      <SnackbarWrapper>
        <RouterProvider router={ router }>
          <DndProvider backend={ HTML5Backend }>
            <Router />
          </DndProvider>
        </RouterProvider>
      </SnackbarWrapper>
    </Theme>
  )
}

const Root = ({
  store,
  router,
}) => {
  return (
    <Provider store={ store }>
      <RootApp
        store={ store }
        router={ router }
      />
    </Provider>
  )
}

export default Root
